import React from 'react'
import PropTypes from 'prop-types'
import FinancialAccountItem from './FinancialAccountItem'
import classnames from 'classnames'

import styles from './FinancialAccountsList.module.scss'

const MASK_LENGTH = 8
const CHARS_TO_DISPLAY = 4

const FinancialAccountRow = (props) => {
  const {
    isHeaderRow,
    name,
    accountNumber,
    totalEmv,
    accountNameLabel,
    showMarketValue,
    isAccountNumberMasked,
  } = props

  const maskedNumber = (accountNumber) => {
    let maskedNumber = '--'
    if (accountNumber && accountNumber !== '') {
      const lastFourDigits = accountNumber.slice(-CHARS_TO_DISPLAY)
      maskedNumber = lastFourDigits.padStart(MASK_LENGTH + (CHARS_TO_DISPLAY - lastFourDigits.length), 'x')
    }
    return maskedNumber
  }

  const parseTotalEmv = (totalEmv) => {
    let parsedValue = '--'
    if (typeof totalEmv === 'number') {
      parsedValue = totalEmv
    }
    return parsedValue
  }

  const parseName = (accountName) => {
    if (accountName !== '') {
      return accountName
    }
    return '--'
  }

  const columnStyles = isHeaderRow ?
    styles.financialAccountHeader : styles.rowItem

  const hideColumOnMobileStyles = isHeaderRow ?
    classnames(styles.hideOnMobile, styles.financialAccountHeader) :
    styles.rowItem

  const accountNumberValue = isAccountNumberMasked ?
    maskedNumber(accountNumber) : accountNumber

  const isTwoColumnLayout = (!showMarketValue)

  const groupStyles = isTwoColumnLayout ? styles.accountSettingsMobileGroup : styles.mobileGroup

  const accountNumberStyles = isTwoColumnLayout ? columnStyles : hideColumOnMobileStyles

  return (
    <div className={styles.financialAccountRow} data-test-id={`financialAccountRow-${name}`}>
      <div className={groupStyles}>
        <FinancialAccountItem
          className={columnStyles}
          value={isHeaderRow ? accountNameLabel : parseName(name)} />
        <FinancialAccountItem
          className={accountNumberStyles}
          value={isHeaderRow ? 'Account Number' : accountNumberValue} />
      </div>
      {showMarketValue &&
        <FinancialAccountItem
          className={columnStyles}
          isBalance={!isHeaderRow}
          value={isHeaderRow ? 'Market Value' : parseTotalEmv(totalEmv)} />
      }
    </div>
  )
}

FinancialAccountRow.defaultProps = {
  name: '--',
  totalEmv: '--',
  accountNumber: '--',
  isHeaderRow: false,
}

FinancialAccountRow.propTypes = {
  name: PropTypes.string,
  totalEmv: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  accountNumber: PropTypes.string,
  isHeaderRow: PropTypes.bool,
  accountNameLabel: PropTypes.string.isRequired,
  showMarketValue: PropTypes.bool.isRequired,
  isAccountNumberMasked: PropTypes.bool.isRequired
}

export default FinancialAccountRow



// WEBPACK FOOTER //
// ./src/components/Client/FinancialAccountsList/FinancialAccountRow.jsx